import {Store} from './store';
import {PropertyType, ResourceType} from 'common/widgets/property-filter-menu/models/types';
import customPropertyClient from 'common/report/queries/app-api/custom-properties-client';

export interface ComposedProperties {
  [variable: string]: any;
}

export interface CustomProperty {
  name: string;
  description: string;
  resourceType?: ResourceType;
  displayFormula: string;
  composedProperties: ComposedProperties;
  referencedDirectlyBy: number[];
  referencedBy: number[];
  referencedRawEventProperties: string[];
  propertyType?: PropertyType;
  user?: number;
  isVisible?: boolean;
  isLocked?: boolean;
  canUpdateLocked?: boolean;
  canUpdateVisible?: boolean;
  canUpdateBasic?: boolean;
  // customPropertiesStore holds the assumption that key (customPropertyId) of a
  // customProperty never changes, but this is no longer true now that we give
  // an inline custom properties a session only ID, from which the user can
  // convert to a real customPropertyId by 'save permanently'. We therefore need
  // a way to communicate to listeners of the store that the old Id is invalid
  // and here is the new Id
  newCustomPropertyId?: number;
}

export interface CustomProperties {
  [customPropertyId: string]: CustomProperty;
}

export default new Store<CustomProperties>({
  apiClient: customPropertyClient,

  transform: {
    index: (response) =>
      response.results.reduce(
        (accumulater, currentValue) => ({
          ...accumulater,
          ...{[currentValue.customPropertyId]: currentValue},
        }),
        {},
      ),
    update: (response) => {
      const results = response.results;
      return {k: results && results.customPropertyId, v: results};
    },
  },

  defaultValue: {},
});
